export enum CookieConsentServiceCategory {
    ESSENTIAL = 'essential',
    FUNCTIONAL = 'functional',
    MARKETING = 'marketing',
    EXTERNAL_MEDIA = 'external-media',
}

export enum CookieConsentServiceProviderKey {
    CONDA = 'conda',
    ZOHO = 'zoho',
    ZOHO_BOOKINGS = 'zoho_bookings',
    ZOHO_SURVEY = 'zoho_survey',
    ZOHO_PAGESENSE = 'zoho_pagesense',
    ZOHO_FORMS = 'zoho_forms',
    JENTIS = 'jentis',
    HOTJAR = 'hotjar',
    GOOGLE_ANALYTICS = 'google_analytics',
    GOOGLE_ADS_CONVERSIONS = 'google_ads_conversions',
    GOOGLE_ANALYTICS_AUDIENCES = 'google_analytics_audiences',
    GOOGLE_ADS_REMARKETING = 'google_ads_remarketing',
    META_PIXEL = 'meta_pixel',
    TWITTER_TAG = 'twitter_tag',
    LINKEDIN_INSIGHT = 'linkedin_insight',
    FACEBOOK = 'facebook',
    INSTAGRAM = 'instagram',
    GOOGLE_MAPS = 'google_maps',
    OPEN_STREET_MAP = 'open_street_map',
    VIMEO = 'vimeo',
    X_EMBED = 'x_embed',
    YOUTUBE = 'youtube',
    TRUST_INDEX = 'trust_index',
}
